import { makeStyles } from "@material-ui/core/styles";
import React, { useState, useEffect } from "react";
// core components
import GridItem from "../../components/Grid/GridItem.js";
import GridContainer from "../../components/Grid/GridContainer.js";
import CustomInput from "../../components/CustomInput/CustomInput.js";
import CardHeader from "../../components/Card/CardHeader.js";
import CardBody from "../../components/Card/CardBody.js";
import CustomSelect from "../../components/CustomInput/CustomSelect";
import PropTypes from "prop-types";

const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0",
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
  },
};

export default function Criterion({ id, data, updateData }) {
  const defaultData = {
    oznaka: "",
    naziv: "",
    tip: "min",
    jedinica_mjere: "",
    koeficijent: NaN,
    status: true,
  };

  const [criterionData, setCriterionData] = useState(
    data && Object.keys(data).length > 0 ? data : defaultData
  );

  useEffect(() => {
    updateData(id, criterionData);
  }, [criterionData]);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setCriterionData({ ...criterionData, [id]: value });
  };

  const handleStatusChange = (e) => {
    const value = e.target.value === "active";
    setCriterionData({ ...criterionData, status: value });
  };

  const useStyles = makeStyles(styles);
  const classes = useStyles();

  const optionsStatus = [
    { value: "active", label: "aktivan" },
    { value: "inactive", label: "neaktivan" },
  ];

  const optionsTip = [
    { value: "min", label: "min" },
    { value: "max", label: "max" },
  ];

  return (
    <>
      <CardHeader color="success">
        <h4 className={classes.cardTitleWhite}>
          Kriterijum{" "}
          {criterionData.oznaka === "" ||
          criterionData.oznaka === undefined ||
          criterionData.oznaka === null
            ? id + 1
            : criterionData.oznaka}
        </h4>
      </CardHeader>
      <CardBody>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <CustomInput
              labelText="Oznaka"
              id="oznaka"
              type="text"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                value: criterionData.oznaka,
                onChange: handleChange,
              }}
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <CustomInput
              labelText="Naziv"
              id="naziv"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                value: criterionData.naziv,
                onChange: handleChange,
              }}
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <CustomSelect
              labelText="Tip"
              id="tip"
              options={optionsTip}
              value={criterionData.tip}
              onChange={(e) =>
                setCriterionData({ ...criterionData, tip: e.target.value })
              }
              error={criterionData.tip === ""}
              success={criterionData.tip !== ""}
              formControlProps={{
                fullWidth: true,
              }}
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <CustomInput
              labelText="Jedinica mjere"
              id="jedinica_mjere"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                value: criterionData.jedinica_mjere,
                onChange: handleChange,
              }}
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <CustomInput
              labelText="Koeficijent"
              id="koeficijent"
              type="number"
              min="0"
              max="1"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                value: criterionData.koeficijent,
                onChange: handleChange,
              }}
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <CustomSelect
              labelText="Status"
              id="status"
              options={optionsStatus}
              value={criterionData.status ? "active" : "inactive"}
              onChange={handleStatusChange}
              error={criterionData.status === ""}
              success={criterionData.status !== ""}
              formControlProps={{
                fullWidth: true,
              }}
            />
          </GridItem>
        </GridContainer>
      </CardBody>
    </>
  );
}

Criterion.propTypes = {
  id: PropTypes.number,
  data: PropTypes.object,
  updateData: PropTypes.func,
};
